// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2hAAC","checkboxCol":"Table_checkboxCol__1PDEr","emailCol":"Table_emailCol__2KyPU","actionCol":"Table_actionCol__22v4J"};